import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 2rem;
  padding: 2rem;
  text-align: center;
`;

export const ErrorIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #ffebee;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;

  &::before {
    content: "!";
    font-size: 48px;
    font-weight: bold;
    color: #d32f2f;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: #d32f2f;
  margin: 0;
`;

export const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  max-width: 500px;
  margin: 0;
`;

export const ButtonContainer = styled.div`
  margin-top: 1rem;
`;
